import { create } from "zustand";
import { persist } from "zustand/middleware";

const SettingStore = create(
  persist(
    (set) => ({
      currentTab: "admininfo",
      setCurrentTab: (_tabName) => {
        set(() => ({
          currentTab: _tabName,
        }));
      },
    }),
    {
      name: "SettingStorePath",
    }
  )
);

export default SettingStore;
